import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Edit, Plus, Trash2, Zap } from "lucide-react";

// Trigger/action automations.
const AutomationsTab = ({
  actionLabels,
  automationLogs,
  automations,
  deleteAutomation,
  setAutomationOpen,
  setEditingAutomation,
  setNewAutomation,
  toggleAutomation,
  triggerLabels,
}) => {
  return (
    <div className="automations-view">
      <div className="view-header">
        <h1>Automatyzacje</h1>
        <Button onClick={() => { setEditingAutomation(null); setNewAutomation({ name: "", trigger_type: "new_client", trigger_params: {}, action_type: "send_message", action_params: { text: "" } }); setAutomationOpen(true); }}>
          <Plus size={18} /> Nowa reguła
        </Button>
      </div>

      {automations.length === 0 ? (
        <Card className="empty-state">
          <CardContent>
            <Zap size={48} strokeWidth={1} />
            <h3>Brak automatyzacji</h3>
            <p>Stwórz reguły automatyzujące powtarzalne czynności</p>
          </CardContent>
        </Card>
      ) : (
        <div className="automations-list">
          {automations.map(auto => (
            <Card key={auto.id} className={`automation-card ${!auto.enabled ? 'disabled' : ''}`}>
              <CardContent>
                <div className="automation-header">
                  <div className="automation-info">
                    <div className="automation-name">
                      <Zap size={16} className={auto.enabled ? 'zap-active' : ''} />
                      <h3>{auto.name}</h3>
                    </div>
                    <div className="automation-rule">
                      <Badge variant="outline">Gdy: {triggerLabels[auto.trigger_type] || auto.trigger_type}</Badge>
                      {auto.trigger_type === 'no_workout_x_days' && auto.trigger_params?.days && (
                        <span className="trigger-param">({auto.trigger_params.days} dni)</span>
                      )}
                      <ArrowRight size={14} />
                      <Badge variant="secondary">{actionLabels[auto.action_type] || auto.action_type}</Badge>
                    </div>
                    {auto.action_type === 'send_message' && auto.action_params?.text && (
                      <p className="automation-preview">"{auto.action_params.text.substring(0, 80)}{auto.action_params.text.length > 80 ? '...' : ''}"</p>
                    )}
                  </div>
                  <div className="automation-actions">
                    <Button variant={auto.enabled ? "default" : "outline"} size="sm" onClick={() => toggleAutomation(auto)}>
                      {auto.enabled ? 'Wł' : 'Wył'}
                    </Button>
                    <Button variant="ghost" size="sm" onClick={() => {
                      setEditingAutomation(auto);
                      setNewAutomation({
                        name: auto.name,
                        trigger_type: auto.trigger_type,
                        trigger_params: auto.trigger_params || {},
                        action_type: auto.action_type,
                        action_params: auto.action_params || { text: "" }
                      });
                      setAutomationOpen(true);
                    }}>
                      <Edit size={14} />
                    </Button>
                    <Button variant="ghost" size="sm" onClick={() => deleteAutomation(auto.id)}>
                      <Trash2 size={14} />
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}

      {automationLogs.length > 0 && (
        <div className="automation-logs-section">
          <h2>Ostatnie akcje</h2>
          <div className="automation-logs-list">
            {automationLogs.slice(0, 20).map(log => (
              <div key={log.id} className="automation-log-item">
                <Zap size={14} className="log-icon" />
                <div className="log-details">
                  <span className="log-name">{log.automation_name}</span>
                  <span className="log-client">{log.client_name}</span>
                </div>
                <Badge variant="outline" className="log-action">{actionLabels[log.action_type] || log.action_type}</Badge>
                <span className="log-date">{new Date(log.executed_at).toLocaleDateString('pl-PL')}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AutomationsTab;
